export const MULTICALL_ADDR = {
  1: "0xeefba1e63905ef1d7acba5a8513c70307c1ce441",
  5: "0x77dCa2C955b15e9dE4dbBCf1246B4B85b651e50e",
  56: "0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B",
  97: "0x6e5bb1a5ad6f68a8d7d6a5e47750ec15773d6042",
  42161: "0x842eC2c7D803033Edf55E478F461FC547Bc54EB2",
};
export const NFT_ADDR = {
  42161: "0x2536e60cBe7fA8EF4dd5F583Ec00b466323D065b",
  97: "0x546f90448844eC6A69592E0D36bF6f6E03e5E76d",
};

export const USDT_ADDR = {
  42161: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
  97: "0x27fcbe8eC747e302b26711741dbbDa7826466d1F",
};

export const BALANCE_ADDR = {
  1: "0xF9e037dCF792BA8c4a0cA570EAC7CbCbAFabD9D4"
}